// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"be9d4542","61":"4c2b7ec0","321":"45d37f88","343":"d8198594","360":"fc6f1333","406":"cf8e88ec","487":"784f6379","647":"421f2b3d","749":"f64b43fc","759":"689b0fd5","787":"eff1209f","889":"1dffb2ae"}[chunkId] + ".chunk.js";
};